import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { AssetSubStatus, IconWithTooltip } from "../../../helper/fixcode";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../Shared/PageLoader";
import { useSelector } from "react-redux";

export default function ReportAssetMovementComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [assetMovementList, setAssetMovementList] = useState([]);
  const refDataGrid = useRef(null);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Movement`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetMovementList(0);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetMovementList = async (assetMovementId) => {
    try {
      // refDataGrid?.current?.instance?.beginCustomLoading();
      let body = {
        requestMovementId: assetMovementId,
        statusId: 0,
        userId: user?.userId,
      };
      const response = await reportService.getAssetMovementList(body);
      setAssetMovementList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetMovementList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={25}
                    caption={""}
                    allowExporting={false}
                    allowSearch={false}
                    allowFiltering={false}
                    allowSorting={false}
                    cellRender={(data) => {
                      const rowData = data?.data;
                      const idPrefix = `icon-${rowData?.id}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            {props?.featurePermission?.canView && (
                              <>
                                <span>
                                  <IconWithTooltip
                                    id={`${idPrefix}-view`}
                                    className="iconify-size mr-1"
                                    title="View"
                                    tooltip="View"
                                    icon="solar:document-text-outline"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      navigate("/asset-movement-preview", {
                                        state: {
                                          requestMovementId:
                                            rowData?.requestMovementId,
                                          movementIndentNo:
                                            rowData?.movementIndentNo,
                                          sourceUrl: "ReportAssetMovement",
                                          isReport: true,
                                        },
                                      });
                                    }}
                                  />
                                </span>
                              </>
                            )}
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="movementIndentNo"
                    caption="Movement No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="assetStatusName"
                    caption="Status"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(e) => {
                      let color = "#28A745";
                      // if (
                      //   e.data?.statusId === AssetSubStatus.AssetMovementInDraftMode
                      // )
                      //   color = "#494545ff";
                      // else if (
                      //   e.data?.statusId === AssetSubStatus.AssetMovementApproved
                      // )
                      //   color = "#4CAF50";
                      // else if (
                      //   e.data?.statusId ===
                      //   AssetSubStatus.AssetMovementSendforApproval
                      // )
                      //   color = "#FF9800";

                      if (
                        e.data?.statusId === AssetSubStatus.AssetRequestPending
                      )
                        color = "#494545ff";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetMovementInDraftMode
                      )
                        color = "#4CAF50";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetMovementApproved
                      )
                        color = "#4CAF50";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetMovementSendforApproval
                      )
                        color = "#FF9800";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetMovementRequestRecall
                      )
                        color = "#ee0a0aff";

                      return (
                        <div>
                          <span style={{ color }}>
                            {e.data?.assetStatusName}
                          </span>
                          {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                                         {e.data?.currentUserId > 0
                                           ? e.data?.currentUserName
                                           : e.data?.toName}
                                       </div> */}
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="requestedDate"
                    caption="Movement Date"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />
                  <Column
                    dataField="assetRequestSubNo"
                    caption="Asset Request No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  {/* <Column
                                 dataField="fromName"
                                 caption="From"
                                 allowSearch={true}
                                 allowFiltering={false}
                               /> */}

                  {/* <Column
                                 dataField="fromProjectName"
                                 caption="From Project"
                                 allowSearch={true}
                                 allowFiltering={false}
                               /> */}
                  <Column
                    dataField="toProjectName"
                    caption="Project"
                    allowSearch={true}
                    allowSorting={true}
                    //alignment={"center"}
                    allowFiltering={false}
                    cellRender={(data) => {
                      if (data?.data?.toProjectName) {
                        return (
                          <>
                            <span>{data?.data?.toProjectName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.toProjectName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="From Project"
                    allowSearch={true}
                    allowSorting={true}
                    //alignment={"center"}
                    allowFiltering={false}
                    cellRender={(data) => {
                      if (data?.data?.fromProjectName) {
                        return (
                          <>
                            <span>{data?.data?.fromProjectName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.toProjectName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="assetDescriptions"
                    caption="Asset Description"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="transportVendorName"
                    caption="Vendor"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="fromName"
                    caption="From"
                    allowSearch={true}
                    allowSorting={true}
                    //alignment={"center"}
                    allowFiltering={false}
                    cellRender={(data) => {
                      if (data?.data?.fromName) {
                        return (
                          <>
                            <span>{data?.data?.fromName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.fromDepartment ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="toName"
                    caption="To"
                    allowSearch={true}
                    allowSorting={true}
                    //alignment={"center"}
                    allowFiltering={false}
                    cellRender={(data) => {
                      if (data?.data?.toName) {
                        return (
                          <>
                            <span>{data?.data?.toName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.toDepartment ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  {/* <Column
                                 dataField="fromLocation"
                                 caption="Location"
                                 allowSearch={true}
                                 allowSorting={true}
                                 //alignment={"center"}
                                 allowFiltering={false}
                                 cellRender={(data) => {
                                   if (data?.data?.fromLocation) {
                                     return (
                                       <>
                                         <span>{data?.data?.fromLocation ?? ""}</span>
                                         <br />
                                         <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                                           {data?.data?.toLocation ?? ""}
                                         </div>
                                       </>
                                     );
                                   } else {
                                     return "";
                                   }
                                 }}
                               /> */}
                  {/* <Column
                                 dataField="fromLocation"
                                 caption="From Location"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               /> */}
                  {/* <Column
                                 dataField="toProjectName"
                                 caption="To Project"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               />
                               <Column
                                 dataField="toLocation"
                                 caption="To Location"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               /> */}
                  {/* <Column
                                 dataField="requestSubject"
                                 caption="Subject"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               />
                               <Column
                                 dataField="requestTypeName"
                                 caption="Request Type"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               /> */}
                  {/* <Column
                                 dataField="locationName"
                                 caption="Location"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               />
                               <Column
                                 dataField="requestedCount"
                                 caption="No Of Assets"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 alignment={"center"}
                                 allowSorting={true}
                               /> */}
                  {/* <Column
                                 dataField="note"
                                 caption="Note"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               />
                               <Column
                                 dataField="remark"
                                 caption="Remark"
                                 allowSearch={true}
                                 allowFiltering={false}
                                 allowSorting={true}
                               />               */}
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetMovementList(0);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
